
export default {
  data() {
    return {
      open: false,
    };
  },
  watch:{
    open:function(v){
      if(v){
        document.body.style.overflow= "hidden";
      }else{
        document.body.style.overflow= "auto";
      }
    }
  },
  mounted() {
    this.$nuxt.$on("closePaymentAddress", () => {
      this.open = false;
    });
    this.$nuxt.$on("openPaymentAddress", () => {
      this.open = true;
    });
  },
};
